import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconMail } from '@tabler/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FeedbackModal, { onSubmitValue } from '@mygpt/app/chat/components/LikeButton/FeedbackModal';
import ReviewButton from '@mygpt/app/chat/components/LikeButton/ReviewButton';
import { TransferToHuman } from '@mygpt/app/chat/components/TransferToHuman';
import { feedbackType, messageRating } from '@mygpt/app/chat/services';
import { ratingType } from '@mygpt/types';

interface LikeButtonProps {
  rating?: ratingType;

  aiId: string;
  sessionId: string;
  messageId: string;

  pageSource: string;

  callback?: ({ messageId, rating }: { messageId: string; rating: number }) => void;
}

const LikeButton: React.FC<LikeButtonProps> = ({ aiId, callback, messageId, pageSource, rating, sessionId }) => {
  const { t } = useTranslation();
  const [opened, { close, open }] = useDisclosure(false);
  const [modalType, setModalType] = useState<feedbackType>('good');

  const [activeType, setActiveType] = useState<feedbackType | ''>('');

  const onSubmit = (values: onSubmitValue) => {
    const param = {
      ai_id: aiId,
      session_id: sessionId,
      message_id: messageId,
      rating: (modalType === 'good' ? 2 : -1) as ratingType,

      feedback_content: values.feedbackContent,
      feedback_metadata: values.feedbackMetadata,
    };

    messageRating(param)
      .then(() => {
        setActiveType(modalType);
        callback && callback({ rating: param.rating, messageId });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (rating) {
      setActiveType(rating === 2 ? 'good' : 'bad');
    }
  }, [rating]);

  return (
    <>
      <ReviewButton
        active={activeType}
        onReview={(type) => {
          open();
          setModalType(type);
        }}
      />
      <FeedbackModal
        type={modalType}
        opened={opened}
        onClose={close}
        onSubmit={onSubmit}
        transferBtn={
          <TransferToHuman pageSource={pageSource} messageId={messageId} sessionId={sessionId}>
            <Button variant="outline" leftSection={<IconMail size={16} />}>
              {t('settings.transfer.title')}
            </Button>
          </TransferToHuman>
        }
      />
    </>
  );
};

export default LikeButton;
